/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Вид для формы условий оплаты в форме организатора совместных покупок
   * (используется для формы организационного сбора и для формы предоплаты)
   */
  app.JointPurchasePaymentsFormView = app.ValidatedFormView.extend({
    events: {
      'focus .field': 'savePosition'
    },
    inputsSelector: 'input.input_styled',
    afterRun: function () {
      this.collection = new app.Collection();
      this.$targetElement = this.$(this.targetElement);
      this.success(this.model, this.model.toJSON());
      this.listenTo(this.collection, 'update', this.save);
      this.listenTo(this.collection, 'reset', this.save);
      this.listenTo(this.collection, 'change', this.save);
    },
    run: function (options) {
      //селектор элемента, в который будет происходить рендер
      if (options && options.targetElement) {
        this.targetElement = options.targetElement;
      }
      app.ValidatedFormView.prototype.run.apply(this, arguments);
    },
    render: function () {
      var that = this;

      this.$targetElement.html('');

      _.each(this.collection.models, (function (model) {
        var view = new app.JointPurchasePaymentFormView({model: model});
        if (!this.childViews.paymentViews) {
          this.childViews.paymentViews = [];
        }
        this.childViews.paymentViews.push(view);
        that.$targetElement.append(view.render());
      }).bind(this));

      this.setFocusToLastInput();
    },
    setFocusToLastInput: function () {
      if (this.lastInputPosition >= 0) {
        this.$(this.inputsSelector).eq(this.lastInputPosition).focus().select();
      }
    },
    getData: function () {
      var data = {
        user_id: this.model.get('user_id')
      };
      data[this.model.api_field_name] = this.collection.toJSON();
      return data;
    },
    success: function (model, response) {
      var fieldName = this.model.api_field_name,
        models = response[fieldName];
      
      //Переводим sum_to и qty, чтобы лишний раз не вызывался change на модели
      _.each(models, function (model) {
        if (!model.sum_to) {
          model.sum_to = '';
        }
        if (!model.qty) {
          model.qty = 0;
        }
      });
      
      if (response && models && _.isArray(models)) {
        this.collection.reset(models, {
          dont_save: true
        });
      }
      
      this.onSave = false;
      this.render();
    },
    error: function () {
      app.helpers.ErrorHelper.globalValidationError([{
        message: ''
      }], 'При сохранинии данных совместной покупки');
      
      this.onSave = false;
    },
    save: function (collection, options) {
      if (options && options.dont_save) {
        return;
      }
      app.ValidatedFormView.prototype.save.apply(this, arguments);
    },
    /**
     * Сохранение порядкового номера текущего инпута, чтобы после перерисовки поставить фокус в то же место
     * @param e
     */
    savePosition: function (e) {
      var $inputs = this.$(this.inputsSelector),
        $target = this.$(e.currentTarget),
        lastPosition = $inputs.index($target);
      
      if (lastPosition >= 0) {
        this.lastInputPosition = lastPosition;
      }
    }
  });
})();

}.call(window));